import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import AppointmentCalenderProVds from '../../../../components/Web/AppointmentScheduleRedesign/AppointmentCalenderProVds';
import * as appointmentScheduleActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import appointmentSchedule from '../../reducer';
import ContactInfoReducer from '../../../ContactInfo/reducer';
import * as appointmentScheduleSelectors from '../../selectors/appointmentScheduleSelectors';
import * as ContactInfoActions from '../../../ContactInfo/actions';
import ContactInfoSaga from '../../../ContactInfo/sagas'
import taggingSaga from '../../../Common/Tagging.js/sagas';
import * as taggingActions from '../../../Common/Tagging.js/actions';

const mapStateToProps = (state) => {
  const appointmentScheduleSelector = appointmentScheduleSelectors.selectData(state);
  const appointmentScheduleState = state.appointmentSchedule || {};
  const appointmentScheduleResponse =
    (state.appointmentSchedule.appointmentScheduleResponse && state.appointmentSchedule.appointmentScheduleResponse.output) || {};
  const currentView = state.currentView || {};
  const cartDetails = state.cartDetails && state.cartDetails.cartDetailsJson ? state.cartDetails.cartDetailsJson : {};
  const cartDetailsState = state.cartDetails;
  const appointmentPhoneNumber =
    state.cartDetails && state.cartDetails.cartDetailsJson ? state.cartDetails.cartDetailsJson.primaryUserInfo?.address?.phoneNumber : '';
  const appointmentEmailId =
    state.cartDetails && state.cartDetails.cartDetailsJson ? state.cartDetails.cartDetailsJson.primaryUserInfo?.address?.emailId : '';
  const selectDateR = state.appointmentSchedule && state.appointmentSchedule.dateObj && state.appointmentSchedule.dateObj.selectDateR;
  const phoneAPiResponse = state?.contactInfo?.phoneAPiResponse ? state?.contactInfo?.phoneAPiResponse : {};

  // email validation
  const isEmailSuccess = state.appointmentSchedule ? state.appointmentSchedule.emailAPiResponse : {};
  const { accMainEmailVal } = state.appointmentSchedule;
  const { emailMaxAttempts } = state.appointmentSchedule;
  const { isUniversalProfileCreated } = state?.contactInfo;
  const isNonVzConsentCheckboxChecked = state.appointmentSchedule?.isNonVzConsentCheckboxChecked;
  const reminderTypeR = state.appointmentSchedule?.reminderTypeR

  return {
    appointmentScheduleSelector,
    appointmentScheduleState,
    appointmentScheduleResponse,
    currentView,
    cartDetails,
    appointmentPhoneNumber,
    cartDetailsState,
    selectDateR,
    appointmentEmailId,
    isEmailSuccess,
    accMainEmailVal,
    emailMaxAttempts,
    isUniversalProfileCreated,
    phoneAPiResponse,
    isNonVzConsentCheckboxChecked,
    reminderTypeR,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...appointmentScheduleActions, ...ContactInfoActions, ...taggingActions }, dispatch);
}
const withReducer = compose(injectReducer({ key: 'appointmentSchedule', reducer: appointmentSchedule }), injectReducer({key: 'contactInfo', reducer: ContactInfoReducer}));

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withSaga = compose(injectSaga({ key: 'appointmentSchedule', saga }, injectSaga({key: 'contactInfo', saga: ContactInfoSaga}), injectSaga({ key: 'taggingDetails', saga: taggingSaga })));
export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect,
  )(AppointmentCalenderProVds),
);
